import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { TitlePlaceholderLoader } from "@similarweb/ui-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledInfoWrapper = styled(FlexColumn)`
    row-gap: 4px;
`;

export const StyledTitle = styled.p`
    ${setFontVariant("subTitle3", colorsPalettes.carbon[400])};

    margin: 0;
    font-size: 14px;
`;

export const StyledText = styled.p`
    ${setFontVariant("body2", colorsPalettes.carbon[400])};

    margin: 0;
`;

export const StyledTitleLoader = styled(TitlePlaceholderLoader)`
    height: 44px;
    width: 150px;
`;
